import { Box, Typography, SxProps, Theme } from "@mui/material";
import { SectionContainer } from "../../../modules/SectionContainer/SectionContainer";
import { SectionTitle } from "../../../modules/SectionTitle/SectionTitle";

const careerSteps = [
  {
    year: "1年目",
    title: "自社開発で「正しい開発」を身につける",
    description:
      "まず自社サービスの開発に携わります。動くものを作れること、設計を意識した実装ができること——この2つをしっかり身につけることが1年目のゴールです。実際の業務システム（約200名が使う勤怠管理システム）を題材に、仕様通りに実装してリリースまでやり切る経験を積みます。",
  },
  {
    year: "2年目",
    title: "後輩の指導 ＋ 外部案件へ初参画",
    description:
      "基礎が固まったら、新しく入ったメンバーの指導役を担います。同時に外部クライアントの案件にも参画開始。最初は先輩がアサインされているチームに追加人員として入るので、いきなり一人で放り込まれることはありません。先輩と並走しながら、外部案件の進め方を学びます。",
  },
  {
    year: "3年目以降",
    title: "一人で外部案件を担い、チームを率いる",
    description:
      "外部案件の動き方が掴めてきたら、フルで一つの案件を担当します。さらにその先では、自分がチームリーダーとなり、複数メンバーを率いてクライアントの要望を実現する立場へ。大手企業のプロジェクトでチームを動かせるエンジニアは、市場でも本当に希少な存在です。",
  },
];

export const CareerPathSection = () => {
  return (
    <SectionContainer sx={{ background: "#f8f9fa", padding: { md: "100px 0", xs: "60px 0" } }}>
      <SectionTitle sx={{ fontSize: { md: "40px", xs: "26px" } }}>入社してから、どう動くか。</SectionTitle>

      <Box sx={timelineContainerSx}>
        {careerSteps.map((step, index) => (
          <Box key={index} sx={timelineItemSx}>
            <Box sx={timelineLeftSx}>
              <Typography sx={yearSx}>{step.year}</Typography>
              <Box sx={dotSx} />
              {index < careerSteps.length - 1 && <Box sx={lineSx} />}
            </Box>
            <Box sx={timelineRightSx}>
              <Typography sx={titleSx}>{step.title}</Typography>
              <Typography sx={descriptionSx}>{step.description}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </SectionContainer>
  );
};

const timelineContainerSx: SxProps<Theme> = {
  maxWidth: "800px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: { md: "48px", xs: "32px" },
};

const timelineItemSx: SxProps<Theme> = {
  display: "flex",
  gap: { md: "32px", xs: "20px" },
  marginBottom: { md: "0", xs: "0" },
};

const timelineLeftSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: { md: "100px", xs: "70px" },
  flexShrink: 0,
};

const yearSx: SxProps<Theme> = {
  fontSize: { md: "16px", xs: "14px" },
  fontWeight: 700,
  color: "#22A1B9",
  marginBottom: "12px",
  whiteSpace: "nowrap",
};

const dotSx: SxProps<Theme> = {
  width: "16px",
  height: "16px",
  borderRadius: "50%",
  background: "linear-gradient(135deg, #22A1B9, #00BFA5)",
  flexShrink: 0,
};

const lineSx: SxProps<Theme> = {
  width: "2px",
  flex: 1,
  minHeight: { md: "80px", xs: "60px" },
  background: "linear-gradient(180deg, #22A1B9, #00BFA5)",
  marginTop: "8px",
};

const timelineRightSx: SxProps<Theme> = {
  flex: 1,
  paddingBottom: { md: "48px", xs: "32px" },
};

const titleSx: SxProps<Theme> = {
  fontSize: { md: "20px", xs: "17px" },
  fontWeight: 700,
  color: "#222222",
  marginBottom: "12px",
};

const descriptionSx: SxProps<Theme> = {
  fontSize: { md: "15px", xs: "14px" },
  color: "#666666",
  lineHeight: 1.9,
};
